import getListViewState from './getListViewState';

export function isCopilotResultsTabVisible(): boolean {
    return !!getListViewState().copilotResultsTableViewId;
}

export function getCopilotResultsTableViewId(): string | undefined {
    return getListViewState().copilotResultsTableViewId;
}

export function getPreviousTableViewId(): string | undefined {
    return getListViewState().previousTableViewId;
}
